module.exports = __webpack_public_path__ + "img/liuxiaohong.e479ba9f.png";